import { Download, Phone } from "lucide-react";
import { useLang } from "@/i18n";
import { PHONES } from "@/lib/site";

export default function MobileCtaBar({ onDownload }) {
    const { t } = useLang();
    return (
        <div
            className="pb-safe fixed inset-x-0 bottom-0 z-40 border-t border-emerald-900/10 bg-white/95 p-3 backdrop-blur-md md:hidden"
            data-testid="mobile-cta-bar"
        >
            <div className="flex gap-2.5">
                <button
                    type="button"
                    onClick={onDownload}
                    data-testid="mobile-download-app-button"
                    className="flex h-12 flex-1 items-center justify-center gap-2 rounded-full bg-brand font-bold text-white shadow-lg shadow-emerald-600/25 transition-colors hover:bg-brand-dark"
                >
                    <Download className="h-4 w-4" />
                    {t.ctaBar.download}
                </button>
                <a
                    href={`tel:${PHONES[0].tel}`}
                    data-testid="mobile-call-now-button"
                    className="flex h-12 flex-1 items-center justify-center gap-2 rounded-full border-2 border-brand font-bold text-brand transition-colors hover:bg-brand-soft"
                >
                    <Phone className="h-4 w-4" />
                    {t.ctaBar.call}
                </a>
            </div>
        </div>
    );
}
